export const categories = [
  { slug: "yule-bagua", name: "娱乐八卦", icon: "ri-chat-smile-2-line", description: "娱乐圈最新动态，明星八卦一网打尽" },
  { slug: "mingxing-heiliao", name: "明星黑料", icon: "ri-spy-line", description: "深度爆料明星不为人知的另一面" },
  { slug: "wanghong-fancha", name: "网红反差", icon: "ri-user-smile-line", description: "网红人设崩塌，台前幕后大揭秘" },
  { slug: "meiri-dasai", name: "每日大赛", icon: "ri-fire-line", description: "每日热点赛事，吃瓜群众集结地" },
  { slug: "shishi-redian", name: "实时热点", icon: "ri-flashlight-line", description: "24小时追踪全网最新吃瓜热点" },
];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  hotIndex: number;
  readCount: number;
  commentCount: number;
  tags: string[];
  content: ArticleSection[];
}

export interface ArticleSection {
  type: "heading" | "paragraph" | "image";
  level?: number;
  text?: string;
  imageUrl?: string;
  imageAlt?: string;
}

export const featuredArticles: Article[] = [
  {
    id: "article-001",
    title: "某顶流男星深夜密会神秘女子，酒店共度八小时全记录",
    excerpt: "据知情人士透露，该男星近期新剧正在热播，却在这个节骨眼被拍到与神秘女子深夜约会，全程亲密互动不断，引发粉丝集体崩溃。",
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20paparazzi%20style%20night%20shot%20of%20a%20celebrity%20couple%20walking%20into%20a%20luxury%20hotel%20lobby%20at%20night%2C%20dramatic%20lighting%2C%20blurry%20background%2C%20urban%20night%20scene%2C%20mysterious%20atmosphere%2C%20editorial%20photojournalism%20style%2C%20warm%20golden%20light%20spilling%20from%20hotel%20entrance&width=800&height=600&seq=article-001&orientation=landscape",
    author: "吃瓜小编",
    publishDate: "2026-06-30",
    hotIndex: 98765,
    readCount: 1250000,
    commentCount: 38520,
    tags: ["顶流男星", "深夜密会", "酒店", "独家爆料"],
    content: [
      { type: "paragraph", text: "近日，一则重磅消息在娱乐圈炸开了锅。据多位目击者证实，某当红顶流男星在刚刚结束新剧宣传活动后，深夜独自驱车前往市区某五星级酒店，随后一位身着黑色连衣裙的神秘女子出现，两人在酒店大堂短暂交谈后一同进入电梯。" },
      { type: "heading", level: 2, text: "八小时密会全过程" },
      { type: "paragraph", text: "根据酒店内部监控显示，两人于当晚11点23分进入酒店，直到次日早上7点45分才分别离开。期间该男星曾独自下楼取外卖，神情轻松，似乎对此次约会十分满意。值得注意的是，该女子全程戴着口罩和墨镜，刻意回避镜头，身份至今成谜。" },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20warm%20ambient%20lighting%2C%20elegant%20interior%20design%2C%20empty%20hallway%20with%20soft%20carpet%20and%20wall%20sconces%2C%20mysterious%20cinematic%20mood%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-001-img1&orientation=landscape", imageAlt: "酒店走廊实拍" },
      { type: "heading", level: 2, text: "粉丝集体崩溃，工作室紧急回应" },
      { type: "paragraph", text: "消息传出后，该男星的粉丝群体瞬间炸锅。超话社区一度瘫痪，大量粉丝发帖表达震惊与失望。有粉丝表示：'刚追完新剧就给我看这个？'也有理性粉丝呼吁：'请给艺人私人空间。'" },
      { type: "paragraph", text: "该男星工作室于6月30日上午紧急发布声明，称'艺人目前单身，与照片中的女子仅为普通朋友关系，请大家不要过度解读'。然而这份声明并未平息舆论，反而引发更多质疑。" },
    ],
  },
  {
    id: "article-002",
    title: "某知名女网红直播翻车，美颜滤镜失效后判若两人引热议",
    excerpt: "拥有千万粉丝的知名女网红在近日直播中遭遇技术故障，美颜滤镜突然失效，真实容貌与平日精修照片差距巨大，直播间弹幕瞬间炸裂。",
    category: "wanghong-fancha",
    categoryName: "网红反差",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20split%20screen%20concept%20showing%20contrast%20between%20a%20glamorous%20filtered%20selfie%20and%20a%20natural%20candid%20portrait%2C%20soft%20studio%20lighting%2C%20beauty%20influencer%20aesthetic%2C%20pastel%20pink%20and%20white%20background%2C%20editorial%20beauty%20photography%20style&width=800&height=600&seq=article-002&orientation=landscape",
    author: "吃瓜小编",
    publishDate: "2026-06-29",
    hotIndex: 89320,
    readCount: 980000,
    commentCount: 45210,
    tags: ["网红翻车", "直播事故", "美颜滤镜", "反差"],
    content: [
      { type: "paragraph", text: "直播翻车早已不是新鲜事，但这次的主角却让吃瓜群众格外兴奋。这位拥有超过千万粉丝的女网红，平日以'天然美女'人设圈粉无数，却在近日一场直播中遭遇了史上最尴尬的技术故障。" },
      { type: "heading", level: 2, text: "美颜失效的十秒钟" },
      { type: "paragraph", text: "据悉，在直播进行到约30分钟时，该网红的直播设备突然出现短暂卡顿，美颜滤镜瞬间失效约10秒钟。就是这短短10秒，让她的真实容貌毫无遮掩地展现在数百万在线观众面前。与平日的精致面容相比，判若两人的画面让弹幕瞬间被问号和'？？？'刷屏。" },
      { type: "paragraph", text: "有眼尖的网友迅速截图，将美颜前后的对比图发到社交平台，短短一小时内话题阅读量突破2亿。大量网友惊呼：'原来这就是科技的力量！''互联网果然没有丑女人，只有不会用滤镜的女人。'" },
      { type: "heading", level: 2, text: "当事人回应：谁还没个真实的样子" },
      { type: "paragraph", text: "事后，该网红发布了一条视频回应此事。她坦诚地表示：'美颜确实是每个主播都会用的工具，这不代表我在欺骗谁。真实的我也许不够完美，但这才是生活的本来面貌。'这番坦诚的回应反而为她赢得了一波好感，不少网友表示：'至少敢于面对，比那些死不承认的强多了。'" },
    ],
  },
  {
    id: "article-003",
    title: "娱乐圈最大合同纠纷曝光！某一线女星被索赔三亿违约金",
    excerpt: "近日，一份法院传票在网络上疯传。某一线女星因单方面解约被经纪公司告上法庭，索赔金额高达三亿元人民币，创下国内娱乐圈违约金新纪录。",
    category: "yule-bagua",
    categoryName: "娱乐八卦",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20legal%20document%20and%20contract%20on%20a%20dark%20mahogany%20desk%20with%20a%20gavel%20in%20the%20background%2C%20cinematic%20lighting%2C%20tense%20atmosphere%2C%20law%20and%20entertainment%20concept%2C%20warm%20spotlight%20on%20paperwork&width=800&height=600&seq=article-003&orientation=landscape",
    author: "娱乐探长",
    publishDate: "2026-06-28",
    hotIndex: 76540,
    readCount: 860000,
    commentCount: 32100,
    tags: ["合同纠纷", "天价违约金", "一线女星", "解约"],
    content: [
      { type: "paragraph", text: "娱乐圈的天价合同纠纷又添新案例。一份据称来自某知名经纪公司的民事诉讼状近日在网络上疯传，被告方正是目前炙手可热的某一线女星，案件涉及金额高达三亿元人民币。" },
      { type: "heading", level: 2, text: "解约背后的利益纠葛" },
      { type: "paragraph", text: "据知情人士透露，该女星在去年凭借一部爆款古装剧一夜爆红后，迅速接到了多个国际品牌的代言邀约。然而按照原经纪合同，这些代言收入的大头将归属经纪公司。这或许成为双方矛盾激化的导火索。" },
      { type: "heading", level: 2, text: "三亿违约金如何计算" },
      { type: "paragraph", text: "法律界人士分析，三亿元的索赔金额并非凭空而来。通常包括：预期收益损失、品牌代言违约金、已投入的培养成本等多重因素。如果法院最终支持这一诉求，将创造国内娱乐圈违约金的新纪录。" },
      { type: "paragraph", text: "目前，该女星方面尚未对此事做出公开回应，但其社交媒体账号的最新动态停留在三天前，疑似有意回避舆论风波。" },
    ],
  },
  {
    id: "article-004",
    title: "某选秀节目黑幕曝光！冠军内定录音外流引发众怒",
    excerpt: "一段疑似选秀节目制作组的内部录音在社交平台疯传，录音中清晰提到了提前内定冠军的相关对话，引发参赛选手粉丝和观众的强烈不满。",
    category: "shishi-redian",
    categoryName: "实时热点",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20with%20spotlight%20and%20microphone%20on%20a%20talent%20show%20set%2C%20behind%20the%20scenes%20vibe%2C%20dark%20backstage%20area%20with%20production%20equipment%2C%20moody%20cinematic%20lighting%2C%20tension%20and%20controversy%20atmosphere&width=800&height=600&seq=article-004&orientation=landscape",
    author: "选秀观察员",
    publishDate: "2026-06-27",
    hotIndex: 92100,
    readCount: 1100000,
    commentCount: 56700,
    tags: ["选秀黑幕", "内定冠军", "录音外流", "节目造假"],
    content: [
      { type: "paragraph", text: "选秀节目有剧本早已是公开的秘密，但这一次，一份内部录音的曝光却让事态走向了不可控的方向。某热门选秀节目在其总决赛前夕，一段疑似制作组内部讨论的录音被匿名账号发布到社交平台。" },
      { type: "heading", level: 2, text: "录音内容触目惊心" },
      { type: "paragraph", text: "在这段长达三分多钟的录音中，可以清晰地听到多名疑似节目组高层在讨论最终排名安排。其中一人明确表示：'冠军必须给XXX，这是投资方指定的，没得商量。'另一人则附和道：'观众投票那边我们可以操作，数据不用太担心。'" },
      { type: "paragraph", text: "这段录音一经曝光，立即在网络上掀起轩然大波。多个参赛选手的粉丝群体联合发声，要求节目组公开透明的投票数据。相关话题在微博热搜榜上连续霸榜超过24小时。" },
    ],
  },
  {
    id: "article-005",
    title: "某男团成员被爆恋爱实锤，粉丝后援会宣布集体脱粉",
    excerpt: "当红男团成员被拍到与圈外女友牵手逛街，照片清晰度极高，粉丝后援会连夜发布声明宣布暂停应援活动。偶像恋爱是否应该被允许再次成为热议话题。",
    category: "yule-bagua",
    categoryName: "娱乐八卦",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20young%20Korean%20style%20idol%20couple%20holding%20hands%20walking%20on%20a%20shopping%20street%2C%20casual%20fashion%2C%20bright%20daylight%2C%20paparazzi%20style%20candid%20photography%2C%20urban%20street%20scene%2C%20soft%20natural%20lighting&width=800&height=600&seq=article-005&orientation=landscape",
    author: "偶像观察家",
    publishDate: "2026-06-26",
    hotIndex: 85400,
    readCount: 920000,
    commentCount: 41200,
    tags: ["男团恋爱", "粉丝脱粉", "偶像失格", "应援暂停"],
    content: [
      { type: "paragraph", text: "偶像恋爱是否等于'失格'？这个老生常谈的话题因为一起最新事件再次被推到风口浪尖。某当红男团的人气成员被娱乐记者拍到与一名圈外女性手牵手逛街，画面清晰，无可辩驳。" },
      { type: "heading", level: 2, text: "粉丝后援会连夜行动" },
      { type: "paragraph", text: "照片曝光后不到三小时，该成员的全国粉丝后援会便在社交平台发布正式声明，宣布'即日起暂停所有应援活动，直至艺人方给出合理解释'。声明措辞严厉，要求成员本人正视粉丝感受。" },
      { type: "heading", level: 2, text: "两极化评论：理解还是愤怒？" },
      { type: "paragraph", text: "事件发酵后，舆论呈现明显两极分化。一部分网友认为：'偶像也是人，有恋爱自由。''追星不是绑架，给艺人一些空间吧。'而另一部分粉丝则态度坚决：'既然选择做偶像，就要遵守偶像的游戏规则。''我花的每一分钱不是为了看你谈恋爱的。'" },
    ],
  },
  {
    id: "article-006",
    title: "某综艺节目录制现场冲突视频流出，两位嘉宾大打出手",
    excerpt: "一段综艺节目录制现场的视频引发全网关注。视频中两位知名艺人在录制过程中因意见不合发生激烈争执，最终演变为肢体冲突，节目录制被迫中断。",
    category: "shishi-redian",
    categoryName: "实时热点",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20chaotic%20TV%20studio%20set%20with%20cameras%20and%20lights%2C%20two%20people%20in%20heated%20argument%20silhouettes%2C%20dramatic%20stage%20lighting%2C%20tense%20reality%20show%20atmosphere%2C%20crew%20members%20rushing%20to%20intervene%2C%20behind%20the%20scenes%20drama&width=800&height=600&seq=article-006&orientation=landscape",
    author: "综艺前线",
    publishDate: "2026-06-25",
    hotIndex: 95800,
    readCount: 1350000,
    commentCount: 62100,
    tags: ["综艺冲突", "大打出手", "录制中断", "现场视频"],
    content: [
      { type: "paragraph", text: "综艺节目现场失控的一幕被现场观众偷偷录下并传到网络。这段长达两分钟的视频中，两位知名艺人在某综艺节目的游戏环节中因对规则理解不同而发生激烈争吵，情绪失控之下竟然演变为肢体冲突。" },
      { type: "heading", level: 2, text: "视频还原事件经过" },
      { type: "paragraph", text: "视频画面显示，起初两人只是就游戏得分产生分歧，言语间火药味渐浓。在某一方说出'你玩不起就别玩'后，另一方突然起身推搡对方，随即两人扭打在一起。现场工作人员和嘉宾纷纷上前劝架，场面一度十分混乱。" },
      { type: "paragraph", text: "节目组在事发后迅速清场，并暂停了当天的录制。有现场观众透露，两位艺人随后被分别带到不同的休息室，直到深夜才陆续离开录制现场。" },
      { type: "heading", level: 2, text: "节目组发布声明" },
      { type: "paragraph", text: "事件发酵24小时后，节目组终于发布官方声明，表示'两位艺人因游戏环节产生误会，目前已握手言和，节目将正常剪辑播出'。然而这一说法并未被网友完全接受，不少人质疑这不过是节目组为了收视率设计的剧本。" },
    ],
  },
];

export const portalArticles: Article[] = [
  {
    id: "article-007",
    title: "某知名导演被爆潜规则女演员，多位当事人勇敢发声",
    excerpt: "近日，三位曾在不同时期与该导演合作过的女演员先后发文，揭露其在片场的不当行为。",
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20film%20director%20chair%20on%20a%20dark%20movie%20set%2C%20spotlight%20casting%20long%20shadows%2C%20cinematic%20noir%20atmosphere%2C%20tense%20mood%2C%20empty%20director%20chair%20with%20megaphone%2C%20film%20clapperboard%20nearby&width=600&height=600&seq=article-007&orientation=squarish",
    author: "圈内知情人",
    publishDate: "2026-06-24",
    hotIndex: 91000,
    readCount: 780000,
    commentCount: 29800,
    tags: ["导演潜规则", "女演员发声", "片场丑闻"],
    content: [],
  },
  {
    id: "article-008",
    title: "某带货主播涉嫌虚假宣传被立案调查，曾日销破亿",
    excerpt: "该主播曾在去年双十一创造单日销售额破亿的记录，如今却因涉嫌虚假宣传面临法律制裁。",
    category: "wanghong-fancha",
    categoryName: "网红反差",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20luxury%20livestreaming%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20but%20with%20a%20dark%20ominous%20shadow%20in%20the%20background%2C%20contrast%20between%20bright%20front%20and%20dark%20back%2C%20ecommerce%20streaming%20concept%2C%20dramatic%20lighting&width=600&height=600&seq=article-008&orientation=squarish",
    author: "消费观察",
    publishDate: "2026-06-23",
    hotIndex: 87300,
    readCount: 690000,
    commentCount: 35400,
    tags: ["直播带货", "虚假宣传", "立案调查", "日销破亿"],
    content: [],
  },
  {
    id: "article-009",
    title: "某女星离婚内幕大揭秘：第三者竟是其闺蜜",
    excerpt: "原本看似和平分手的明星离婚案，近日被扒出背后隐藏的惊人真相，第三者身份令人大跌眼镜。",
    category: "yule-bagua",
    categoryName: "娱乐八卦",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20broken%20wedding%20ring%20on%20a%20mirror%20surface%20reflecting%20three%20silhouettes%2C%20dramatic%20lighting%2C%20emotional%20concept%2C%20betrayal%20theme%2C%20dark%20elegant%20aesthetic%2C%20jewelry%20photography%20style&width=600&height=600&seq=article-009&orientation=squarish",
    author: "婚姻观察",
    publishDate: "2026-06-22",
    hotIndex: 94500,
    readCount: 1150000,
    commentCount: 48700,
    tags: ["明星离婚", "第三者", "闺蜜背叛", "惊人内幕"],
    content: [],
  },
  {
    id: "article-010",
    title: "某顶流歌手被指抄袭，新歌旋律与国外神曲高度雷同",
    excerpt: "音乐博主发布专业对比视频，将两首歌曲的旋律进行逐段比对，相似度令人震惊。",
    category: "shishi-redian",
    categoryName: "实时热点",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20musical%20notes%20sheets%20overlapping%20each%20other%20on%20a%20dark%20background%2C%20one%20slightly%20transparent%2C%20copyright%20infringement%20concept%2C%20dramatic%20contrast%20lighting%2C%20music%20industry%20controversy%2C%20elegant%20minimalist%20composition&width=600&height=600&seq=article-010&orientation=squarish",
    author: "音乐评论人",
    publishDate: "2026-06-21",
    hotIndex: 82100,
    readCount: 720000,
    commentCount: 31200,
    tags: ["歌手抄袭", "旋律雷同", "专业对比", "版权争议"],
    content: [],
  },
];

export const hotArticles: Article[] = [
  ...featuredArticles,
  {
    id: "article-011",
    title: "某影视公司被曝拖欠员工工资，多位艺人工作室解约跑路",
    excerpt: "这家曾出品过多部热门剧集的影视公司，如今却陷入严重财务危机，不仅拖欠员工数月工资，更有多位签约艺人选择提前解约。",
    category: "yule-bagua",
    categoryName: "娱乐八卦",
    imageUrl: "https://readdy.ai/api/search-image?query=An%20empty%20modern%20office%20with%20papers%20scattered%20on%20desks%2C%20abandoned%20workplace%20atmosphere%2C%20dim%20lighting%2C%20financial%20crisis%20concept%2C%20corporate%20drama%2C%20cinematic%20documentary%20style%2C%20cold%20blue%20and%20gray%20tones&width=800&height=600&seq=article-011&orientation=landscape",
    author: "财经娱乐",
    publishDate: "2026-06-20",
    hotIndex: 78900,
    readCount: 650000,
    commentCount: 28300,
    tags: ["影视公司", "拖欠工资", "艺人解约", "财务危机"],
    content: [],
  },
  {
    id: "article-012",
    title: "某综艺常驻嘉宾被替换内幕：与制片人关系不和",
    excerpt: "该嘉宾已连续参加三季节目，却被临时通知不再续约。据内部人士透露，导火索是其与制片人在节目方向上存在严重分歧。",
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20TV%20show%20panel%20with%20one%20empty%20chair%20among%20occupied%20ones%2C%20variety%20show%20set%20design%2C%20bright%20stage%20lights%20contrasting%20with%20the%20empty%20seat%2C%20entertainment%20industry%20politics%20concept%2C%20dramatic%20composition&width=800&height=600&seq=article-012&orientation=landscape",
    author: "综艺内幕",
    publishDate: "2026-06-19",
    hotIndex: 74300,
    readCount: 580000,
    commentCount: 24100,
    tags: ["综艺换人", "嘉宾替换", "制片矛盾", "节目内幕"],
    content: [],
  },
];

export interface Review {
  id: string;
  username: string;
  avatarUrl: string;
  date: string;
  content: string;
  spicyLevel: number;
  articleRef: string;
}

export const reviews: Review[] = [
  {
    id: "review-001",
    username: "吃瓜不嫌事大",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20cute%20watermelon%20character%20avatar%20in%20minimalist%20flat%20design%20style%2C%20round%20icon%2C%20playful%20expression%2C%20green%20and%20red%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-001&orientation=squarish",
    date: "2026-06-30",
    content: "笑死我了，现在的明星真的是一个比一个会玩。不过说真的，这波爆料算是锤得死死的，照片拍得清清楚楚，想洗都没得洗。工作室那个声明更是此地无银三百两，越描越黑。",
    spicyLevel: 9.6,
    articleRef: "article-001",
  },
  {
    id: "review-002",
    username: "互联网嘴替",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20cool%20sunglasses%20emoji%20style%20character%20avatar%2C%20trendy%20design%2C%20yellow%20and%20black%20color%20scheme%2C%20minimalist%20flat%20illustration%2C%20round%20icon%20shape&width=80&height=80&seq=avatar-002&orientation=squarish",
    date: "2026-06-29",
    content: "这才是真正的'照骗'天花板啊！美颜一关直接换人种了属于是。不过人家敢于承认也挺好的，比那些嘴硬到底的强。话说回来，现在谁直播不开美颜啊，大惊小怪。",
    spicyLevel: 9.2,
    articleRef: "article-002",
  },
  {
    id: "review-003",
    username: "娱乐圈纪检委",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20detective%20magnifying%20glass%20character%20avatar%20in%20minimalist%20style%2C%20investigation%20theme%2C%20brown%20and%20cream%20colors%2C%20round%20icon%2C%20mysterious%20vibe&width=80&height=80&seq=avatar-003&orientation=squarish",
    date: "2026-06-28",
    content: "三亿违约金？好家伙，我这辈子都赚不到这么多钱。不过话说回来，这些经纪公司的合同确实坑得很，新人签约的时候什么都不懂，红了就想跑，哪有那么容易。",
    spicyLevel: 8.8,
    articleRef: "article-003",
  },
  {
    id: "review-004",
    username: "理性吃瓜人",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20thoughtful%20owl%20character%20avatar%20in%20minimalist%20flat%20design%2C%20wise%20expression%2C%20warm%20brown%20and%20beige%20colors%2C%20round%20icon%2C%20reading%20glasses&width=80&height=80&seq=avatar-004&orientation=squarish",
    date: "2026-06-27",
    content: "选秀节目这点事早就不新鲜了，从超女时代开始就是这样。只不过以前没互联网，操作起来比较方便。现在的观众不好糊弄了，录音一出来全露馅。节目组这波公关怕是要加班到天亮。",
    spicyLevel: 8.5,
    articleRef: "article-004",
  },
  {
    id: "review-005",
    username: "键盘侠本侠",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20cool%20robot%20typing%20on%20keyboard%20avatar%20in%20minimalist%20style%2C%20tech%20theme%2C%20blue%20and%20white%20colors%2C%20round%20icon%2C%20playful%20design&width=80&height=80&seq=avatar-005&orientation=squarish",
    date: "2026-06-26",
    content: "粉丝花的钱都够在上海买套房了，结果偶像拿去谈恋爱？这买卖确实不太划算。不过我寻思偶像也是人啊，总不能一辈子不谈恋爱吧。建议粉丝们理性追星，别太真情实感。",
    spicyLevel: 9.0,
    articleRef: "article-005",
  },
];

export const aboutReviews: Review[] = [
  {
    id: "about-review-001",
    username: "资深媒体人张先生",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20professional%20middle%20aged%20man%20portrait%20avatar%20in%20minimalist%20flat%20style%2C%20news%20media%20professional%2C%20dark%20hair%2C%20warm%20smile%2C%20round%20icon%2C%20clean%20simple%20design&width=80&height=80&seq=avatar-media-001&orientation=squarish",
    date: "2026-05-15",
    content: "作为从业二十年的媒体人，我见证了无数娱乐资讯平台的兴衰。黑料吃瓜网是我见过最专业、最及时的吃瓜平台之一。他们的内容审核机制在业内也是数一数二的，既保证了信息的时效性，又兼顾了真实性。",
    spicyLevel: 9.5,
    articleRef: "",
  },
  {
    id: "about-review-002",
    username: "互联网大V老王",
    avatarUrl: "https://readdy.ai/api/search-image?query=A%20trendy%20young%20influencer%20avatar%20in%20minimalist%20flat%20style%2C%20cool%20hairstyle%2C%20modern%20fashion%2C%20round%20icon%2C%20orange%20and%20white%20color%20scheme&width=80&height=80&seq=avatar-bigv-001&orientation=squarish",
    date: "2026-04-22",
    content: "这年头能坚持做免费内容的平台不多了。黑料吃瓜网不仅免费，内容质量还一直在线。我每天上班第一件事就是打开他们网站看看今天有什么新瓜，已经成了我生活的一部分。",
    spicyLevel: 9.3,
    articleRef: "",
  },
];